import { useAtom } from 'jotai'

import { judgeApprovalRequestStore } from 'src/stores'

export const useJudgeApprovalRequestStore = () => {
  const [judgeApprovalRequestStoreValue, setJudgeApprovalRequestStoreValue] = useAtom(
    judgeApprovalRequestStore.state
  )

  return {
    judgeApprovalRequestStoreValue,
    setJudgeApprovalRequestStoreValue,
  }
}
